import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { ImageWrapper, InfoWrapper, RulesWrapper, Wrapper, SpanWrapper, ButtonsWrapper } from './wrappers';
import { Icon, SecondaryTextBaseBold, SecondaryTextXs400 } from 'atoms';
import { getObjectIcons } from 'utils';
import { FlexCenterWrapper, Mr3 } from 'wrappers';
import { OutlinedButton, SolidButton } from 'molecules';

export const definition = {
  name: 'Badge',
  controller: Controller,
  initialProps: ({ badge, isTemplate, preview, icons }) => ({ badge, isTemplate, preview, icons }),
  props: internalState,
  elements: [{
    wrapper: Wrapper,
    displayState: ({ preview }) => ({ preview }),
    name: 'BadgeWrapper',
    elements: [
      {
        wrapper: FlexCenterWrapper,
        name: 'InfoWrapper',
        elements: [
          {
            component: wrap(Icon, ImageWrapper),
            name: 'Icon',
            renderIf: ({ badge }) => badge.image,
            displayValue: ({ badge, icons }) => icons ? icons[badge.image] : (getObjectIcons({})[badge.image] || getObjectIcons({})['Medal'])
          },
          {
            wrapper: InfoWrapper,
            name: 'Data',
            elements: [
              {
                component: SecondaryTextBaseBold,
                name: 'Title',
                displayValue: ({ badge }) => badge.name ?? '',
              },
              {
                component: wrap(SecondaryTextXs400, RulesWrapper),
                name: 'Rules',
                displayValue: ({ badge }) => badge.description ?? '',
              }
            ]
          }
        ]
      },
      {
        wrapper: wrap(ButtonsWrapper, SpanWrapper),
        name: 'Buttons',
        elements: [
          {
            component: wrap(OutlinedButton, Mr3),
            name: 'SecondaryButton',
            displayValue: ({ }) => ({ big: true }),
            bindings: ({ isTemplate, badge }) => ({ title: isTemplate ? 'Edit & Add' : badge.active ? 'Deactivate' : 'Activate' })
          },
          {
            component: SolidButton,
            name: 'PrimaryButton',
            bindings: ({ isTemplate }) => ({ title: isTemplate ? 'Add Badge' : 'Edit', big: true })
          }
        ]
      }
    ]
  }
  ]
}

const Badge = ContainerComponent(definition)

export default Badge;